module.exports = __webpack_public_path__ + "static/how-it-works-step-1-376ed028b8238a07cdb06020cfde25eb.png";